import React from 'react';
import ReactDOM from 'react-dom';

class ModalPortal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isEnabled } = this.props;

    if (typeof isEnabled === 'boolean' && !isEnabled) {
      return <React.Fragment>{this.props.children}</React.Fragment>;
    }

    return (
      <React.Fragment>
        {ReactDOM.createPortal(this.props.children, document.getElementById('app-modal'))}
      </React.Fragment>
    );
  }
}

export default ModalPortal;
